import React, { useEffect, useMemo, useRef, useState } from 'react'
import { AutoComplete, Button, Flex, Form, Input, Modal, Select } from 'antd'
import './AddRelative.scss'
import * as  selectOptionsApi from '../../../api/selectOptions/selectOptionsApi'
import { fommatSelectOption } from '../../../until'
import useToast from '../../../hook/useToast'
import { useForm } from 'antd/es/form/Form'
import { ICustomerDetail_V4, Item } from '../../../api/customer/customerApi'
import useDebounce from '../../../hook/useDebounce'
import { addBusiness_V4, getInfoBusiness_V2 } from '../../../api/business/businessApi'
import { selectorInfoUser } from '../../../store/slices/infoUserSlice'
import { useSelector } from 'react-redux'
import { PhoneOutlined, PlusSquareOutlined } from '@ant-design/icons'
import { icon_delelte } from '../../../components/ExportImgFigma'
import { IPhone } from '../../../api/relatives/relativesApi'
import { InforSelectedCodeCustomer } from './AddRelativeAddCustomer'
import { FormInstance, FormProps } from 'antd/lib'
import useThrottle from '../../../hook/useThrottle'
import { NO_DATA } from '../../../env'
import { selectorCategoryCarIds } from '../../../store/slices/categoryCarSlice'
import useLoading from '../../../hook/useLoading'

interface Props {
  show: boolean
  infoCustomer?: ICustomerDetail_V4;
  modalClose?: () => void
  onSuccess?: () => void
  onSubmitFormModal?: (iSsuccess: boolean, message?: string) => void
}


interface CustomerFilterSearch {
  searchProvince?: string;
  searchDistrict?: string
  searchProfession?: string
}


export interface IRelativeBusinessADD {
  taxCode?: string
  businessName?: string
  email?: string
  phoneBusiness?: IPhone[]
  foundingDate?: string
  address?: string
  businessField?: Item
  businessRelationship?: Item
  province?: Item
  district?: Item
}

const AddBusiness: React.FC<Props> = (props) => {
  const {
    show, infoCustomer,
    modalClose, onSuccess, onSubmitFormModal
  } = props
  const inputRef = useRef<FormInstance>(null);
  const [form] = useForm()
  const pushToast = useToast();
  const pushLoading = useLoading();

  const { unitTemp } = useSelector(selectorInfoUser)
  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)

  const [sLTaxCodeBusiness, setSLTaxCodeBusiness] = useState<selectOptionsApi.ITag_V2[]>([])
  const [sLBusinessRelationship, setSLBusinessRelationship] = useState<selectOptionsApi.ISelectOption[]>([])
  const [sLProfession, setSLProfession] = useState<selectOptionsApi.ISelectOption[]>([])

  const [sLTypePhone, setSLTypePhone] = useState<selectOptionsApi.ISelectOption[]>([])

  const [phoneTypeTmp, setPhoneTypeTmp] = useState<{ [key: number]: number }>({})
  const [inforSelectedCodeCustomer, setInforSelectedCodeCustomer] = useState<InforSelectedCodeCustomer>()
  const [paginationCodeBusiness, setPaginationCodeBusiness] = useState({ current: 1, pageSize: 30, total: 0 });
  const [searchFilter, setSearchFilter] = useState<CustomerFilterSearch>()

  const isDisable = useMemo(() => {
    return inforSelectedCodeCustomer?.id !== undefined;
  }, [inforSelectedCodeCustomer]);

  const gSLTaxCodeBusiness = useDebounce(async (current: number = 1, search?: string) => {
    pushLoading(true)
    if (!infoCustomer?.id) return
    const result = await selectOptionsApi.getCLTaxCodeBusiness(
      permittedCategoryCarIds,
      infoCustomer?.id, search, unitTemp ?? undefined, 30, current
    );
    if (result?.status) {
      setSLTaxCodeBusiness(prev =>
        current === 1
          ? result.data                // load lần đầu
          : [...prev, ...result.data]  // append
      );
      setPaginationCodeBusiness(prev => ({
        ...prev,
        current,
        total: result.total || 0
      }));
    } else {
      pushToast(result?.message, "error")
    }
    pushLoading(false)
  }, 1000)

  const gSBusinessRelationship = async () => {
    pushLoading(true)
    const result = await selectOptionsApi.getListRelatives();
    if (result?.status) {
      setSLBusinessRelationship(fommatSelectOption(result.data))
    } else {
      pushToast(result?.message, "error")
    }
    pushLoading(false)
  }

  const gSLProfession = useDebounce(async () => {
    pushLoading(true)
    const result = await selectOptionsApi.getCLProfession(searchFilter?.searchProfession);
    if (result?.status) {
      setSLProfession(fommatSelectOption(result.data))
    } else {
      pushToast(result?.message, "error")
    }
    pushLoading(false)
  }, 500)



  const gSLTypePhone = async () => {
    pushLoading(true)
    const result = await selectOptionsApi.getListTypePhone();
    if (result?.status) {
      setSLTypePhone(fommatSelectOption(result.data))
    } else {
      pushToast(result?.message, "error")
    }
    pushLoading(false)
  }


  const gInfoBusinessr = async (taxCode: string) => {
    pushLoading(true)
    form.resetFields()
    const result = await getInfoBusiness_V2(undefined, taxCode)
    if (result?.status) {
      const { email, businessName, phoneBusiness, profession, businessRelationship } = result.data

      const validEmail = email?.map(email => ({ email }));
      form.setFieldsValue({
        "taxCode": taxCode,
        "businessName": businessName,
        "phone": phoneBusiness,
        "professionId": profession?.id,
        "email": validEmail,
        "businessRelationshipId": businessRelationship?.id
      });
    } else {
      pushToast(result?.message, "error")
    }
    pushLoading(false)
  }

  const handleSelectCodeCustomer = (value: InforSelectedCodeCustomer) => {
    if (value.value)
      gInfoBusinessr(value.value)

    setInforSelectedCodeCustomer(value)

  }

  const onPopupScroll = (e: any) => {
    const target = e.target;
    const isBottom =
      target.scrollTop + target.clientHeight >= target.scrollHeight - 20;
    if (!isBottom) return;

    const { current, total } = paginationCodeBusiness;

    const hasMore = sLTaxCodeBusiness.length < total;

    if (!hasMore) return;
    gSLTaxCodeBusiness(current + 1);
  };

  const handleResetAll = () => {
    form.resetFields()

    setInforSelectedCodeCustomer(undefined)
  }
  const submitForm = useThrottle(() => {
    if (inputRef.current) {
      inputRef.current.submit();
    }
  }, 2000);

  const onFormFinish: FormProps["onFinish"] = async (values: any) => {
    const {
      email, taxCode, phone, professionId, businessName, businessRelationshipId, unitTempId
    } = values;
    const validEmail = email.map((item: any) => item?.email).filter((email: any) => typeof email === "string" && email.trim() !== "");
    const result = await addBusiness_V4(
      Number(infoCustomer?.id), taxCode, businessName, phone,
      professionId, validEmail, businessRelationshipId, unitTempId
    )
    if (result?.status) {
      onSubmitFormModal?.(true, result?.message)
    } else {
      onSubmitFormModal?.(false, result?.message)
    }
  }

  useEffect(() => {
    if (show)
      gSLProfession()
  }, [searchFilter?.searchProfession])

  useEffect(() => {
    if (show) {
      // if (!sLRelative.length)
      setSLTaxCodeBusiness([]);
      setPaginationCodeBusiness({ current: 1, pageSize: 30, total: 0 });

      gSLTaxCodeBusiness(1);
      if (!sLBusinessRelationship.length)
        gSBusinessRelationship()
      if (!sLProfession.length)
        gSLProfession()
      if (!sLTypePhone.length)
        gSLTypePhone()
    } else {
      form.resetFields()

      setInforSelectedCodeCustomer(undefined)
      setPhoneTypeTmp({})
    }
  }, [show, unitTemp])

  return (
    <Form
      ref={inputRef}
      form={form}
      className='rs-form add-relative-form'
      onFinish={onFormFinish}
    >
      <Modal
        open={show}
        title='Thêm doanh nghiệp'
        className='rs-modal w-572 footer-content-end add-relative-modal'
        centered
        footer={
          <>
            <Button
              type='primary'
              className='rs-button rs-button--sm'
              onClick={handleResetAll}
            >Làm mới</Button>
            <Button
              type='primary'
              className='rs-button rs-button--sm'
              onClick={submitForm}
            >Lưu</Button></>
        }
        onCancel={modalClose}
      >
        <div className='d-flex flex-column gap-2'>
          <div className="d-flex flex-column gap-2">
            <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
              Mã số thuế
              <div>
                <span className="text-F5222D">*</span>
                :
              </div>

            </p>
            <Form.Item
              layout='vertical'
              name="taxCode"
              rules={[
                { required: true, message: 'Vui lòng nhập mã số thuế' },
                {
                  validator: (_, value) => {
                    if (!value) return Promise.resolve();
                    const regex = /^\d{10}(\d{3})?$/; // 10 hoặc 13 chữ số
                    if (!regex.test(value)) {
                      return Promise.reject('Mã số thuế phải gồm 10 hoặc 13 chữ số');
                    }
                    return Promise.resolve();
                  }
                }
              ]}
            >
              <AutoComplete
                placeholder="Nhập mã số thuế"
                onPopupScroll={onPopupScroll}
                disabled={isDisable}
                options={sLTaxCodeBusiness.map((item) => ({
                  key: item.id,
                  value: item.taxCode,         // Giá trị hiển thị trong ô tìm kiếm
                  label: `${(item.taxCode ?? NO_DATA)} - ${item.username}`, // Gợi ý hiển thị dropdown
                  id: item.id,              // Giá trị thực tế bạn muốn lấy khi chọn
                }))}
                filterOption={(inputValue, option) =>
                  !!option?.value?.toLowerCase().includes(inputValue.toLowerCase())
                }
                onSelect={(value, option) => {
                  handleSelectCodeCustomer(option)
                }}
              >
                <Input className="custom-input-css custom-page-css border" />
              </AutoComplete>
            </Form.Item>

          </div>

          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
              Tên doanh nghiệp
              <div>
                <span className="text-F5222D">*</span>
                :
              </div>

            </p>
            <Form.Item
              layout='vertical'
              name='businessName'
              rules={[
                { required: true, message: "Vui lòng nhập tên doanh nghiệp" }
              ]}
            >
              <Input
                disabled={isDisable}
                placeholder='Tên doanh nghiệp'
                className='custom-input-css custom-page-css border'
              />
            </Form.Item>
          </div>

          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
              Số điện thoại
              <div>
                <span className="text-F5222D">*</span>
                :
              </div>
            </p>
            <Form.List
              name="phone"
              initialValue={[{ phone: "", categoryPhoneId: null }]}
            >
              {
                (fields, { add, remove }) => (
                  <Flex vertical className="gap-10px">
                    {
                      fields.map((field) => (
                        <div key={field.key} className="d-flex gap-1">
                          {/* shouldUpdate để đọc trạng thái categoryPhoneId của từng dòng */}
                          <Form.Item noStyle shouldUpdate>
                            {
                              ({ getFieldValue }) => {
                                const selected = getFieldValue(["phone", field.name, "categoryPhoneId",]);

                                return (
                                  <Form.Item
                                    className="w-full"
                                    name={[field.name, "phone"]}
                                    rules={[
                                      { required: true, message: "Vui lòng nhập số điện thoại" },
                                      () => ({
                                        validator(_, value) {
                                          if (!value) return Promise.resolve();

                                          const phoneType = getFieldValue(["phone", field.name, "categoryPhoneId",]);

                                          if (!phoneType) return Promise.resolve();

                                          const isHome = phoneType === 1;
                                          const isCompany = phoneType === 2;

                                          if (isHome && !/^0\d{9}$/.test(value)) {
                                            return Promise.reject(
                                              new Error(
                                                "Số điện thoại không hợp lệ (10 số, bắt đầu bằng 0)"
                                              )
                                            );
                                          }

                                          if (isCompany && !/^0\d{10,11}$/.test(value)) {
                                            return Promise.reject(
                                              new Error(
                                                "Số điện thoại không hợp lệ (11-12 số, bắt đầu bằng 0)"
                                              )
                                            );
                                          }
                                          return Promise.resolve();
                                        },
                                      }),
                                    ]}
                                  >
                                    <Input
                                      prefix={<PhoneOutlined />}
                                      placeholder="Số điện thoại"
                                      className="custom-input-css custom-page-css border"
                                      type="tel"
                                      disabled={!selected} // Chỉ nhập khi đã chọn loại điện thoại
                                    />
                                  </Form.Item>
                                );
                              }}
                          </Form.Item>
                          <Form.Item
                            name={[field.name, "categoryPhoneId"]}
                            rules={[{ required: true, message: "Vui lòng chọn loại điện thoại" }]}
                          >
                            <Select
                              disabled={isDisable}
                              options={sLTypePhone}
                              placeholder="Loại điện thoại"
                              className="custom-page-css border rounded overflow-hidden w-150-px"

                              onChange={(val) => {
                                // Nếu bỏ chọn => xóa luôn số điện thoại
                                if (val == null) {
                                  const curr = (form?.getFieldValue?.("phone") ?? []).slice();
                                  if (curr[field.name]) curr[field.name].phone = "";
                                  form?.setFieldsValue?.({ phone: curr });
                                }
                              }}
                            />
                          </Form.Item>
                          <img
                            hidden={fields.length <= 1}
                            src={icon_delelte}
                            alt=""
                            className={`${isDisable ? "d-none" : "rounded-6-px border-f2f4f7 p-7-px bg-white cursor-pointer"}`}
                            onClick={() => remove(field.name)} // dùng field.name an toàn hơn index
                          />
                        </div>
                      ))
                    }
                    <div
                      className={`${isDisable ? "d-none" : "d-flex align-center gap-1 cursor-pointer text-1890FF pt-1 w-fit"}`}
                      onClick={() => add({ phone: "", categoryPhoneId: null })}
                    >
                      <PlusSquareOutlined className="text-sm" />
                      <span className="text-sm">Thêm số điện thoại mới</span>
                    </div>
                  </Flex>
                )
              }
            </Form.List>
          </div>

          <Form.Item
            layout='vertical'
            label='Ngành nghề kinh doanh :'
            name='professionId'
          >
            <Select
              disabled={isDisable}
              placeholder='Ngành nghề kinh doanh'
              className='custom-page-css border rounded overflow-hidden'

              options={sLProfession}

              showSearch
              filterOption={false}
              onSearch={(value) => setSearchFilter({ ...searchFilter, searchProfession: value })}
              onBlur={() => setSearchFilter({ ...searchFilter, searchProfession: '' })}
            />
          </Form.Item>
          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
              Email :
            </p>
            <Form.List
              name="email"
              initialValue={[{}]}
            >
              {(fields, { add, remove }) => (
                <div className='d-flex flex-column gap-1'>
                  {fields.map((field, i) => (
                    <div key={field.key} className="d-flex gap-2">

                      <Form.Item
                        name={[field.name, 'email']}
                        fieldKey={[i, "email"]}
                        className="m-none-form-item text-explan w-full"
                        rules={[
                          {
                            type: 'email',
                            message: 'Email không hợp lệ',
                          },
                        ]}
                      >
                        <Input
                          disabled={isDisable}
                          placeholder="Email"
                          className="custom-input-css custom-page-css border"
                        />
                      </Form.Item>
                      <img
                        hidden={fields.length <= 1}
                        src={icon_delelte}
                        alt=""
                        className={` ${isDisable ? "d-none" : "rounded-6-px border-f2f4f7 p-7-px bg-white cursor-pointer"}`}
                        onClick={() => remove(i)}
                      />
                    </div>
                  ))}
                  <div
                    className={` ${isDisable ? "d-none" : "d-flex align-center gap-1 cursor-pointer text-1890FF pt-1 w-fit"} `}
                    onClick={() => add({})}
                  >
                    <PlusSquareOutlined className="text-sm" />
                    <span className="text-sm">Thêm mail mới</span>
                  </div>
                </div>
              )}
            </Form.List>
          </div>
          <Form.Item
            layout='vertical'
            label='Mối quan hệ :'
            name='businessRelationshipId'

          >
            <Select
              placeholder='Mối quan hệ'
              className='custom-page-css border rounded overflow-hidden'

              options={sLBusinessRelationship}
            />
          </Form.Item>


          {/* <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
            Địa chỉ:
          </p>

          <Form.Item
            layout='vertical'
          >
            <Flex vertical className='gap-4px'>
              <Flex className='gap-10px'>
                <Form.Item
                  label=''
                  name='thanh-pho'
                  className='w-full'
                >
                  <Select
                    placeholder='Chọn tỉnh/thành phố'
                    className='custom-page-css border rounded overflow-hidden'
                     
                    options={sLProvice}
                    value={
                      infoRelativeBusiness?.province
                        ? { value: infoRelativeBusiness.province.id, label: infoRelativeBusiness.province.title }
                        : undefined
                    }
                    labelInValue
                    onChange={(e) => onChaneProvice(e)}

                  />
                </Form.Item>

                <Form.Item
                  label=''
                  name='quan'
                  className='w-full'
                >
                  <Select
                    placeholder='Chọn quận/huyện'
                    className='custom-page-css border rounded overflow-hidden'
                     
                    options={sLDistrict}
                    value={
                      infoRelativeBusiness?.district
                        ? { value: infoRelativeBusiness.district.id, label: infoRelativeBusiness.district.title }
                        : undefined
                    }
                    labelInValue
                    onChange={(e) => setinfoRelativeBusiness({ ...infoRelativeBusiness, district: { id: e.value, title: e.label } })}
                  />
                </Form.Item>
              </Flex>

              <Form.Item
                label=''
                name='dia-chi'
              >
                <Input
                  placeholder='Địa chỉ'
                  className='rs-input rs-input--32'
                  onChange={e => setinfoRelativeBusiness({ ...infoRelativeBusiness, address: e.target.value })}
                />
              </Form.Item>
            </Flex>
          </Form.Item> */}
        </div>

      </Modal >
    </Form>
  )
}

export default AddBusiness
